import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLoaderIconGreen = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 72,
	height: 73,
	viewBox: "0 0 72 73",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M4.43029 38.2272C2.00172 38.3313 0.0898957 40.3928 0.489327 42.7906C1.41062 48.3211 3.61495 53.5813 6.95042 58.1382C11.1559 63.8836 16.9706 68.253 23.6593 70.6937C30.348 73.1345 37.6103 73.537 44.5278 71.8504C51.4453 70.1637 57.7073 66.4637 62.5219 61.2182C67.3365 55.9726 70.4875 49.4172 71.5765 42.3808C72.6654 35.3445 71.6434 28.1432 68.6396 21.6877C65.6359 15.2322 60.7853 9.81237 54.7013 6.11361C49.8758 3.18002 44.4464 1.43357 38.8574 0.988552C36.4343 0.795614 34.5437 2.87672 34.6478 5.30529C34.7518 7.73387 36.816 9.58145 39.2296 9.87011C43.0732 10.3298 46.7919 11.6069 50.1284 13.6354C54.7248 16.4297 58.3893 20.5243 60.6586 25.4013C62.9279 30.2783 63.7 35.7187 62.8773 41.0346C62.0547 46.3504 59.6741 51.3029 56.0368 55.2658C52.3994 59.2287 47.6686 62.024 42.4426 63.2982C37.2166 64.5724 31.7301 64.2684 26.6769 62.4244C21.6237 60.5805 17.2307 57.2795 14.0536 52.9389C11.7473 49.788 10.1568 46.1921 9.37018 42.4019C8.87619 40.0218 6.85887 38.1232 4.43029 38.2272Z",
		fill: "url(#paint0_linear_11278_118395)"
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
		id: "paint0_linear_11278_118395",
		x1: 13.9345,
		y1: 65.1966,
		x2: 83.6126,
		y2: 22.7827,
		gradientUnits: "userSpaceOnUse",
		children: [/* @__PURE__ */ _jsx("stop", {
			offset: .0586068,
			stopColor: "#3DD394"
		}), /* @__PURE__ */ _jsx("stop", {
			offset: .792303,
			stopColor: "#ABE7CE",
			stopOpacity: .2
		})]
	}) })]
});
export default SvgLoaderIconGreen;
